import React, { useState } from 'react';
import { MarkdownRenderer } from '../../components';

interface AiOutputPreviewProps {
  aiSummary: string | null;
}

const PREVIEW_CHARS = 280;

export const AiOutputPreview: React.FC<AiOutputPreviewProps> = ({ aiSummary }) => {
  const [expanded, setExpanded] = useState(false);

  if (!aiSummary?.trim()) {
    return (
      <article className="prompt-col__card">
        <span className="explain__eyebrow">AI output</span>
        <p className="explain__muted">No assistant output was stored for this prompt.</p>
      </article>
    );
  }

  const long = aiSummary.length > PREVIEW_CHARS;
  const preview = long ? `${aiSummary.slice(0, PREVIEW_CHARS).trim()}…` : aiSummary;

  return (
    <article className="prompt-col__card ai-output">
      <div className="prompt-col__block-head">
        <span className="explain__eyebrow">AI output</span>
        {long && (
          <button
            type="button"
            className="prompt-col__toggle"
            onClick={() => setExpanded((v) => !v)}
            aria-expanded={expanded}
          >
            {expanded ? 'Show less' : 'Show full output'}
          </button>
        )}
      </div>
      <div className="prompt-col__text-block prompt-col__text-block--prose">
        {expanded ? (
          <div className="ai-output__body">
            <MarkdownRenderer content={aiSummary} />
          </div>
        ) : (
          <p className="ai-output__preview">{preview}</p>
        )}
      </div>
    </article>
  );
};

export default AiOutputPreview;
